// Import CSS before React components.
import 'bootstrap/dist/css/bootstrap.css';
import 'normalize.css/normalize.css';
import 'react-day-picker/lib/style.css';
import 'font-awesome/css/font-awesome.min.css';
import 'fixed-data-table-2/dist/fixed-data-table.min.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-custom-scroll/dist/customScroll.css';
import './styles/card.css';
import './styles/scroll.css';
import './styles/select.css';

import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { createStoreWithOptions } from '@united-talent-agency/julius-frontend-store';
import { OnyxThemeProvider } from '@united-talent-agency/components';

import Routes from './routes';

import { apiServerUrl } from './support/urls';
import { initializeDataDog } from './support/dataDog';

const store = createStoreWithOptions({ apiServerUrl });

/**
 * Data Dog RUM tracking initialization
 *
 * active host is interrogated against the allowable env flags using this map:
 *    "prod": phonesheet.unitedtalent.com
 *    "staging": phonesheet.staging.unitedtalent.com
 *    "dev": phonesheet.dev.unitedtalent.com
 *    "local": localhost
 */
initializeDataDog(window.location.hostname, ['staging', 'prod']);

function mount(App) {
  return render(
    <Provider store={store}>
      <OnyxThemeProvider>
        <App />
      </OnyxThemeProvider>
    </Provider>,
    document.getElementById('app')
  );
}

mount(Routes);

if (module.hot) {
  module.hot.accept('./routes', () => {
    mount(require('./routes').default);
  });
}
